module.exports = __webpack_public_path__ + "img/icon-k.4c3f0a8f.svg";